import { createModule } from '@vue-storefront/core/lib/module'
import { afterRegistration } from './hooks/afterRegistration'
import { module } from './store'
import { isServer } from '@vue-storefront/core/helpers'

declare const fbq
declare global {
  interface Window { fbq: any; facebookPixelSnippet: any; }
}

if (!isServer) {
  window.facebookPixelSnippet = function(f, b, e, v, callback) {
    let n, t, s;
    if (f.fbq) return;
    n = f.fbq = function() {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.defer = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
    t.onload = callback;
  }
}

const KEY = 'facebook-pixel'
export const FacebookPixel = createModule({
  key: KEY,
  store: { modules: [{ key: KEY, module }] },
  afterRegistration
})
